import {
  CLOSE_QUOTE_RECORDS_DIALOG,
  GET_PURCHASE_RECORDS,
  GET_PURCHASE_RECORDS_ERROR,
  GET_PURCHASE_RECORDS_SUCCESS,
  OPEN_QUOTE_RECORDS_DIALOG
} from './QuoteRecordsDialog.actions'

const quoteRecordsDialogState = {
  error: null,
  loading: false,
  open: false,
  records: []
}

/**
 * The quote records dialog's reducer.
 */
const quoteRecordsDialogReducer = (state = quoteRecordsDialogState, { payload, type }) => {
  switch (type) {
    case CLOSE_QUOTE_RECORDS_DIALOG: {
      return { ...state, open: false }
    }
    case GET_PURCHASE_RECORDS: {
      return { ...state, error: null, loading: true }
    }
    case GET_PURCHASE_RECORDS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_PURCHASE_RECORDS_SUCCESS: {
      return { ...state, error: null, loading: false, records: payload.records }
    }
    case OPEN_QUOTE_RECORDS_DIALOG: {
      return { ...state, open: true }
    }
    default: {
      return state
    }
  }
}

export default quoteRecordsDialogReducer
